<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Animateurs" />
            <AniMateurs />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import AniMateurs from '../Animateur/AniMateurs.vue'

export default {
    name: 'AnimateurPage',
    components: {
        NavBar,
        PageTitle,
        AniMateurs,
        FooterComp,
    }
}
</script>